import React, { useCallback, useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import Navbar from "./components/Navbar";
import OfferBanner from "./components/OfferBanner";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Coverage from "./components/Coverage";
import Services from "./components/Services";
import Fleet from "./components/Fleet";
import Gallery from "./components/Gallery";
import OwnerVideo from "./components/OwnerVideo";
import Reviews from "./components/Reviews";
import WhyUs from "./components/WhyUs";
import Footer from "./components/Footer";
import BookingModal from "./components/BookingModal";
import WhatsAppFloat from "./components/WhatsAppFloat";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 48, color: "#F4F4F5", background: "#0A0A0C", minHeight: "100vh" }}>
          <h1 className="font-display">Something broke the ride.</h1>
          <p>{String(this.state.error)}</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [booking, setBooking] = useState({ open: false, journey: "" });

  const openBooking = useCallback((journey = "") => {
    setBooking({ open: true, journey: journey || "" });
  }, []);
  const closeBooking = useCallback(() => {
    setBooking((b) => ({ ...b, open: false }));
  }, []);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="bg-ink text-bone font-body antialiased">
        <div className="noise-overlay" aria-hidden="true" />
        <Navbar onBook={openBooking} />
        <main>
          <OfferBanner />
          <Hero onBook={openBooking} />
          <Marquee />
          <Coverage />
          <Services onBook={openBooking} />
          <Fleet onBook={openBooking} />
          <Gallery />
          <OwnerVideo />
          <Reviews />
          <WhyUs />
        </main>
        <Footer onBook={openBooking} />
        <BookingModal open={booking.open} journey={booking.journey} onClose={closeBooking} />
        <WhatsAppFloat />
      </div>
    </ErrorBoundary>
  );
}

export default App;
